import { render } from "./infos-legales.vue?vue&type=template&id=1def439a&ts=true"
import script from "./infos-legales.vue?vue&type=script&lang=ts"
export * from "./infos-legales.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/sections-formulaire/infos-legales.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1def439a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1def439a', __exports__)) {
    api.reload('1def439a', __exports__)
  }
  
  module.hot.accept("./infos-legales.vue?vue&type=template&id=1def439a&ts=true", () => {
    api.rerender('1def439a', render)
  })

}


export default __exports__